// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "taxesTooltip__root-20-Bz";
export { _1 as "__esModule", _2 as "taxesTooltip__root" }
export default { "__esModule": _1, "taxesTooltip__root": _2 }
